import { Injectable } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

export interface SeoData {
  title: string;
  metadata: MetaDefinition;
}

@Injectable({
  providedIn: 'root',
})
export class SEOService {
  constructor(private _meta: Meta, private _title: Title, private _router: Router, private _activatedRoute: ActivatedRoute) {}

  updateTitle(title?: string) {
    if (!title) {
      this._router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          map(() => this._activatedRoute),
          map((route) => {
            while (route.firstChild) {
              route = route.firstChild;
            }
            return route;
          }),
          filter((route) => route.outlet === 'primary'),
          mergeMap((route) => route.data)
        )
        .subscribe((event) => {
          this.setTitle(event['title']);
          this.setDescription(event['description']);
        });
    } else {
      this._title.setTitle(title);
    }
  }

  setTitle(title: string): void {
    if (title) {
      this._title.setTitle(title);
    }
  }

  setDescription(description: string): void {
    if (description) {
      this._meta.updateTag({ name: 'description', content: description });
    }
  }
}
